import Sidebar from "../components/Sidebar";
import DragAndDrop from "../components/DragAndDrop";
import { useAdminStatus } from "../hooks/useAdminStatus";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useMobileStatus } from "../hooks/useMobileStatus";
import MobileHeader from "../components/MobileHeader";

const AdminPage = () => {
  const isAdmin = useAdminStatus();
  const isMobile = useMobileStatus();
  const navigate = useNavigate();

  function navigateHome() {
    navigate("/");
  }

  useEffect(() => {
    if (isAdmin !== null && !isAdmin) {
      navigateHome();
    }
  });

  return (
    <div className="container-big">
      {!isMobile && <Sidebar />}
      <div className="container-main container-big">
        {isMobile && <MobileHeader />}
        {isAdmin ? (
          <DragAndDrop />
        ) : (
          <div className="container-column">
            <p>Sie haben keine Berechtigung diese Seite anzuzeigen.</p>
            <button className="basic-button" onClick={navigateHome}>
              Zurück zur Hauptseite
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default AdminPage;
